export default __webpack_public_path__ + "static/media/adriangonzalez.89dc3f16.jpeg";